module.exports = __webpack_public_path__ + "img/medal.a592ce13.svg";